import { makeSelectors } from "../../core/make-selectors";
import { BookInfo } from "./types";
import { createSelector } from "@reduxjs/toolkit";

const baseSelectors = makeSelectors<BookInfo>("bookInfo");

export const getBookInfo = baseSelectors.getData;
export const getBookInfoStatus = baseSelectors.getFetchStatus;
export const getBookInfoResultStatusCode = baseSelectors.getResultStatusCode;

// Memoize to prevent mid-session updates
export const getExpirationDays = createSelector(getBookInfo, (info) => {
  if (info) {
    const expirationDate = new Date(info.expiresAt);
    const expirationMS = expirationDate.valueOf() - Date.now();
    const expirationDays = expirationMS / (1000 * 60 * 60 * 24);
    if (expirationDays < 0) {
      return -1;
    }
    return Math.floor(expirationDays);
  }
  return Number.POSITIVE_INFINITY;
});
